import MentorCheckTasksPage from './mentor-check-tasks-page'

export default MentorCheckTasksPage
